import React, { useState } from 'react';
import { FadeIn } from './ui/FadeIn';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQSection() {
  const faqs = [{
    q: '¿Tengo que dejar de comer lo que me gusta?',
    a: 'No. Solo controlas ingredientes específicos en la ventana nocturna. El resto del día es flexible.'
  }, {
    q: '¿Es seguro si tomo otros medicamentos?',
    a: 'Es un protocolo de hábitos. Aun así, si estás medicado o tienes condiciones médicas, consulta a tu médico.'
  }, {
    q: '¿Cuánto tardan los resultados?',
    a: 'Muchos notan cambios entre la segunda y tercera noche si eliminan irritantes y aplican vaciado completo de forma consistente.'
  }, {
    q: '¿Necesito comprar equipo especial?',
    a: 'No. Todo lo que necesitas está en tu cocina, tu baño y este protocolo.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-navy-900 py-14 md:py-20 relative text-cream-50" data-id="element-37">
      <div className="container mx-auto px-4" data-id="element-38">
        <div className="max-w-[720px] mx-auto" data-id="element-39">
          <div className="flex items-center justify-center gap-3 mb-10" data-id="element-40">
            <div className="w-12 h-px bg-gold-500/30" data-id="element-41" />
            <div className="w-1.5 h-1.5 rotate-45 bg-gold-500/50" data-id="element-42" />
            <div className="w-12 h-px bg-gold-500/30" data-id="element-43" />
          </div>
          <FadeIn data-id="element-44">
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-center mb-12 text-white" data-id="element-45">
              Preguntas Frecuentes
            </h2>
          </FadeIn>

          <div className="space-y-4" data-id="element-46">
            {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-47">
                <div className="bg-navy-800 rounded-xl border border-navy-700 overflow-hidden" data-id="element-48">
                  <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" data-id="element-49">
                    <span className="text-lg font-bold text-white pr-4" data-id="element-50">
                      {faq.q}
                    </span>
                    <ChevronDown className={`text-gold-400 shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} size={24} data-id="element-51" />
                  </button>
                  <AnimatePresence data-id="element-52">
                    {openIndex === index && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.3
                }} data-id="element-53">
                        <div className="px-6 pb-5 text-cream-100/80 text-lg" data-id="element-54">
                          {faq.a}
                        </div>
                      </motion.div>}
                  </AnimatePresence>
                </div>
              </FadeIn>)}
          </div>
        </div>
      </div>
    </section>;
}